import React from 'react';
import {Box} from '@mui/material';
import {BuilderChoiceDebug} from './BuilderChoiceDebug';
import {isPlaceholderPotId} from './builderConstants';

interface PlanRowProps {
  id: string;
  curoId?: string;
  reccId: string | null;
  isSelected: boolean;
  isSubplan: boolean;
  sameReview?: boolean;
  newPlanPotId?: string;
  children: React.ReactNode;
}

export const PlanRow: React.FC<PlanRowProps> = ({
  id,
  curoId,
  reccId,
  isSelected,
  isSubplan,
  sameReview,
  newPlanPotId,
  children,
}) => {
  const mbValue = isSubplan ? 0 : 2;
  return (
    <Box
      id={id}
      data-curo-id={curoId}
      data-pot-id={newPlanPotId || id}
      data-recc-id={reccId || 'New plan'}
      data-selected={isSelected ? 'selected' : 'not-selected'}
      data-is-subplan={isSubplan}
      data-is-new-plan={isPlaceholderPotId(id) ? 'yes' : 'no'}
      data-test="choice-option"
      className={isSubplan ? 'indent' : ''}
      mb={mbValue}
    >
      <BuilderChoiceDebug
        id={id}
        newPlanPotId={newPlanPotId}
        sameReview={sameReview}
        reccId={reccId}
        curoId={curoId}
        isSubplan={isSubplan}
      />
      <Box
        display="flex"
        flexDirection="column"
        gap={0}
        width="100%"
        // paddingLeft={isSubplan ? 1 : 0}
        // mb={isSelected ? 3 : 0.5}
      >
        {children}
      </Box>
    </Box>
  );
};
